import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-phone-icon',
  templateUrl: './phone-icon.component.svg',
  styleUrls: ['phone-icon.component.scss'],
})
export class PhoneIconComponent {
  @Input() height = 18;
  @Input() width = 18;
  @Input() color = '#fff';
}
